import { Avatar, Space } from "antd";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { StyledButton } from "../../Common/Components";
import PermissionCheck from "../../Common/PermissionCheck";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import { getAdjustmentFieldOptions, getAdjustmentTypeOptions } from "./formSetup";
import { findImageByTypes } from "~utilities/findImageByTypes.ts";
import { ImageSizes } from "~enums/imageSizes.ts";
import { ImageTypes } from "~enums/imageTypes.ts";
import ImageView from "../../components/ImageView/ImageView.tsx";

export const getColumns = ({
  formatMessage,
  getTeamName,
  getTeamLink,
  getTeamLogo,
  organizationId,
  sport,
  seasonId,
  customerId,
  handleDeleteIntent,
}) => [
  {
    title: formatMessage({
      id: "adjustmentField",
      defaultMessage: "Adjustment field",
    }),
    dataIndex: "adjustmentField",
    filters: getAdjustmentFieldOptions().map((x) => ({
      ...x,
      text: x.translation,
    })),
    filterSearch: true,
    onFilter: (searchTerm, row) => row.adjustmentField === searchTerm,
  },
  {
    title: formatMessage({
      id: "adjustmentValue",
      defaultMessage: "Adjustment value",
    }),
    dataIndex: "adjustmentValue",
  },
  {
    title: formatMessage({
      id: "adjustmentType",
      defaultMessage: "Adjustment type",
    }),
    dataIndex: "adjustmentType",
    filters: getAdjustmentTypeOptions(),
    onFilter: (searchTerm, row) => row.adjustmentType === searchTerm,
  },
  {
    title: formatMessage({
      id: "team",
      defaultMessage: "Team",
    }),
    key: "team",
    render(value, row) {
      return (
        <PermissionCheck
          permissionKeys={[PermissionNames.ENTITY]}
          permissionOptions={[PermissionOperations.UPDATE]}
          componentToRender={
            <Space size="small">
              <ImageView
                imageUrl={getTeamLogo(`${organizationId}:${row.entityId}`)}
                size={ImageSizes.Small}
                width={25}
                height={25}
                imageType={ImageTypes.Logo}
              />
              {getTeamName(`${organizationId}:${row.entityId}`)}
            </Space>
          }
        >
          <Link className="link" to={getTeamLink(row.entityId)}>
            <Space size="small">
              <ImageView
                imageUrl={getTeamLogo(`${organizationId}:${row.entityId}`)}
                size={ImageSizes.Small}
                width={25}
                height={25}
                imageType={ImageTypes.Logo}
              />
              {getTeamName(`${organizationId}:${row.entityId}`)}
            </Space>
          </Link>
        </PermissionCheck>
      );
    },
  },
  {
    title: null,
    align: "right",
    render: (value, row) => (
      <Space size="small">
        <PermissionCheck
          permissionKeys={[PermissionNames.STANDING_ADJUSTMENT]}
          permissionOptions={[PermissionOperations.UPDATE]}
        >
          <StyledButton type="text" size="small">
            <Link
              to={`/${customerId}/admin/${sport}/${organizationId}/seasons/${seasonId}/standings/adjustments/${row.standingAdjustmentId}`}
            >
              <FormattedMessage id="manage" defaultMessage="manage" />
            </Link>
          </StyledButton>
        </PermissionCheck>
        <PermissionCheck
          permissionKeys={[PermissionNames.STANDING_ADJUSTMENT]}
          permissionOptions={[PermissionOperations.DELETE]}
        >
          <StyledButton
            type="text"
            size="small"
            icon={<i className="fas fa-trash" />}
            onClick={() => handleDeleteIntent(row)}
          />
        </PermissionCheck>
      </Space>
    ),
  },
];
